module.exports = new __parcel__URL__("hi-tom_6.94994fbe.mp3").toString();